import { Space, TextLoader } from '@procurify/ui'

import { AppHeaderLogo } from './components/AppHeaderLogo'
import { AppHeaderLoaderStyled } from './styles/AppHeaderLoaderStyled'

export const AppHeaderLoader = () => {
  return (
    <AppHeaderLoaderStyled>
      <Space direction='horizontal' align='center' justify='space-between'>
        <AppHeaderLogo />

        <TextLoader width={300} height={20} />
      </Space>
    </AppHeaderLoaderStyled>
  )
}

AppHeaderLoader.displayName = 'AppHeaderLoader'
